import Control from "../../Control";
import DateInput from "../DateInput/DateInput";
import TimeEdit from "./TimeEdit";
import Delegate from "../../Delegate";

let moment = require('moment');


export default class WorldTimeEdit extends Control {
	private _timeEdit: TimeEdit;
	private _dateInput: DateInput;
	private EvChanged: Delegate;
	private EvSpinChanged: Delegate;
	private _FloatingLabel: string;


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}


	_initFields(settings: object)
	{
		this.EvSpinChanged = new Delegate();
		this._FloatingLabel = null;
		this.EvChanged = new Delegate();
		this._Value = new Date();
		super._initFields(settings);
	}


	_render()
	{
		super.np_render();
		this.addClass('world-time-edit')

		let m = moment(this._Value || new Date());

		this._dateInput = new DateInput({
			FloatingLabel: this._FloatingLabel,
			ParentNode: this._root,
			Value: m.toDate(),
			EvChanged: () => this.onChange()
		})

		this._timeEdit = new TimeEdit({
			ParentNode: this._root,
			EvSpinChanged: this.EvSpinChanged,
			Value: m.format('HH:mm:ss'),
			EvChanged: () => this.onChange()
		})
	}

	incrementValue(isPlus: boolean, fireEvent: boolean)
	{
		this._timeEdit.incrementValue(isPlus, fireEvent)
	}

	onChange()
	{
		this.EvChanged.fire(this);
	}

	setValue(str: string)
	{
		let m = moment(this._Value);
		this._dateInput.setValue(m.toDate())
		this._timeEdit.setValue(m.format('HH:mm:ss'))
	}

	getValue()
	{
		let m = moment(this._dateInput.getValue());
		return m.format('YYYY-MM-DD') + " " + this._timeEdit.getValue();
	}
}